// Pending internal applications badge count (WS-driven via useInternalApplicationsSocket)

import { useEffect, useSyncExternalStore } from 'react';
import { useAuth } from '../authContext';
import useInternalApplicationsSocket from './useInternalApplicationsSocket';
import {
  fetchPendingInternalApplicationsCountOnce,
  getPendingInternalApplicationsCount,
  subscribePendingInternalApplicationsCount,
} from './internalApplicationsPendingStore';

let hookMountCount = 0;

export function usePendingInternalApplications({ enabled = true } = {}) {
  const { isLoggedIn } = useAuth();
  const wsEnabled = enabled && isLoggedIn;

  useInternalApplicationsSocket({
    enabled: wsEnabled,
    isLoggedIn,
  });

  useEffect(() => {
    if (!wsEnabled) return undefined;

    hookMountCount += 1;
    const isFirstMount = hookMountCount === 1;

    if (isFirstMount) {
      fetchPendingInternalApplicationsCountOnce();
    }

    return () => {
      hookMountCount -= 1;
    };
  }, [wsEnabled]);

  const count = useSyncExternalStore(
    enabled ? subscribePendingInternalApplicationsCount : () => () => {},
    enabled ? getPendingInternalApplicationsCount : () => 0,
    enabled ? getPendingInternalApplicationsCount : () => 0,
  );

  return {
    pendingCount: enabled ? count : 0,
    hasPending: enabled && count > 0,
  };
}
